import React from 'react';
import { OptionText, ToggleContainer, ToggleOption, Highlight } from './styled';

interface ToggleProps {
  options: { id: string; name: string }[];
  selectedValue: string;
  cypress?: string;
  onChange: (value: string) => void;
  stat?: string;
  allowReselect?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({
  options,
  selectedValue,
  cypress,
  stat,
  allowReselect = false,
  onChange
}) => {
  const currentIndex = options.findIndex(o => o.id === selectedValue);

  const goNext = () => {
    const nextIndex = (currentIndex + 1) % options.length;
    onChange(options[nextIndex].id);
  };

  const handleOptionClick = (optionId: string, isSelected: boolean) => {
    if (isSelected) {
      if (allowReselect) {
        goNext();
      }
    } else {
      onChange(optionId);
    }
  };

  return (
    <ToggleContainer data-cy={cypress}>
      <Highlight $index={currentIndex} $count={options.length} />
      {options.map(option => {
        const isSelected = option.id === selectedValue;
        const optionCypress = `${cypress}${isSelected ? '-active' : ''}-option`;

        return (
          <ToggleOption
            key={option.id}
            $isSelected={isSelected}
            onClick={() => handleOptionClick(option.id, isSelected)}
            data-cy={optionCypress}
            data-stat={stat}
            $allowReselect={allowReselect}
          >
            <OptionText tag="body_1" $isSelected={isSelected}>
              {option.name}
            </OptionText>
          </ToggleOption>
        );
      })}
    </ToggleContainer>
  );
};
